import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X, CheckCircle2 } from 'lucide-react';
const purchases = [{
  name: 'Sebastián M.',
  city: 'Buenos Aires',
  time: 'hace 2 minutos'
}, {
  name: 'Florencia R.',
  city: 'Córdoba',
  time: 'hace 5 minutos'
}, {
  name: 'Pablo G.',
  city: 'La Plata',
  time: 'hace 8 minutos'
}, {
  name: 'Andrea L.',
  city: 'Rosario',
  time: 'hace 11 minutos'
}, {
  name: 'Nicolás T.',
  city: 'Mendoza',
  time: 'hace 14 minutos'
}, {
  name: 'Verónica S.',
  city: 'Mar del Plata',
  time: 'hace 17 minutos'
}, {
  name: 'Federico A.',
  city: 'San Miguel de Tucumán',
  time: 'hace 21 minutos'
}, {
  name: 'Mariana C.',
  city: 'Salta',
  time: 'hace 24 minutos'
}, {
  name: 'Gonzalo F.',
  city: 'Neuquén',
  time: 'hace 27 minutos'
}, {
  name: 'Daniela P.',
  city: 'Bahía Blanca',
  time: 'hace 31 minutos'
}, {
  name: 'Maximiliano V.',
  city: 'San Juan',
  time: 'hace 34 minutos'
}, {
  name: 'Romina B.',
  city: 'Resistencia',
  time: 'hace 38 minutos'
}];
export function PurchaseNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const initialTimer = setTimeout(() => setIsVisible(true), 5000);
    return () => clearTimeout(initialTimer);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !isVisible) return;
    const hideTimer = setTimeout(() => setIsVisible(false), 5000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, currentIndex, dismissed]);
  useEffect(() => {
    if (dismissed || isVisible) return;
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setIsVisible(true);
    }, 4000);
    return () => clearTimeout(nextTimer);
  }, [isVisible, dismissed]);
  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsVisible(false);
    setDismissed(true);
  };
  const current = purchases[currentIndex];
  return <div className="fixed bottom-4 left-4 z-[60] pointer-events-none max-w-[calc(100%-2rem)] sm:max-w-[260px]" data-id="element-228">
      <AnimatePresence mode="wait" data-id="element-229">
        {isVisible && !dismissed && <motion.div key={currentIndex} initial={{
        opacity: 0,
        x: -50,
        y: 20
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -50,
        y: 20
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto bg-[#171717] border border-[#F59E0B]/40 rounded-sm shadow-2xl shadow-black/50 backdrop-blur-md overflow-hidden" data-id="element-230">
            <div className="h-1 bg-gradient-to-r from-[#F59E0B] to-[#D97706]" data-id="element-231"></div>

            <div className="p-2.5 flex items-start gap-2" data-id="element-232">
              <div className="relative flex-shrink-0" data-id="element-233">
                <div className="w-7 h-7 bg-[#F59E0B]/10 border border-[#F59E0B]/30 rounded-full flex items-center justify-center" data-id="element-234">
                  <ShoppingBag className="w-3.5 h-3.5 text-[#F59E0B]" data-id="element-235" />
                </div>
                <motion.div className="absolute -top-0.5 -right-0.5 w-3 h-3 bg-[#F59E0B] rounded-full flex items-center justify-center" initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              delay: 0.3,
              type: 'spring',
              stiffness: 300
            }} data-id="element-236">
                  <CheckCircle2 className="w-2 h-2 text-[#0a0a0a]" strokeWidth={3} data-id="element-237" />
                </motion.div>
              </div>

              <div className="flex-1 min-w-0 pr-1" data-id="element-238">
                <p className="text-xs text-white font-medium leading-snug" data-id="element-239">
                  <span className="font-bold" data-id="element-240">{current.name}</span> de{' '}
                  <span className="text-[#F59E0B]" data-id="element-241">{current.city}</span>
                </p>
                <p className="text-[10px] text-[#9CA3AF] mt-0.5" data-id="element-242">
                  compró el MegaPack · {current.time}
                </p>
              </div>

              <button onClick={handleDismiss} className="text-[#9CA3AF] hover:text-white transition-colors flex-shrink-0" aria-label="Cerrar notificación" data-id="element-243">
                <X className="w-3 h-3" data-id="element-244" />
              </button>
            </div>

            <motion.div key={`progress-${currentIndex}`} className="h-0.5 bg-[#F59E0B]/30 origin-left" initial={{
          scaleX: 1
        }} animate={{
          scaleX: 0
        }} transition={{
          duration: 5,
          ease: 'linear'
        }} data-id="element-245" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}